import React, { useEffect, useMemo, useState } from "react";

import PageTitle from "../PageTitle";
import PageSearch from "../PageSearch";
import DialogBox from "../../components/dialog-box/DialogBox";
import EnhancedTable from "../table/Table";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { displayDateFormart, isValidArr } from "../../utility/utils";
import { fetchSBUs } from "../../redux/actions/SBUActions";
import { fetchUsers } from "../../redux/actions/UserActions";
import Loader from "../../components/loader/Loader";
import SBGForm from "./SBUForm";
import { SBUModel } from "../../models/SBUModel";

export type Mode = "add" | "edit";

type iData = {
  id: number;
  name: string;
  description: string;
  sbuuserId: string;
  createdDate: string;
  // status: string;
};

const SBUPage = () => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState<Mode>("add");
  const [editData, setEditData] = useState<SBUModel>();
  const [rootData, setRootData] = useState<iData[]>([]);
  const [filteredData, setFilteredData] = useState<iData[]>([]);

  const allSBUs = useAppSelector((state) => state.sbu.all_SBUs);
  const allUsers = useAppSelector((state) => state.user.all_Users);
  const isSbusFetching = useAppSelector((state) => state.sbu.isSbusFetching);

  const columns = useMemo(() => {
    return [
      {
        id: "name",
        numeric: false,
        disablePadding: false,
        label: "Name",
      },
      {
        id: "description",
        numeric: false,
        disablePadding: false,
        label: "Description",
      },
      {
        id: "sbuuserId",
        numeric: false,
        disablePadding: false,
        label: "User",
      },
      {
        id: "createdDate",
        numeric: false,
        disablePadding: false,
        label: "Created Date",
        width: 150,
      },
      // {
      //   id: "status",
      //   numeric: false,
      //   disablePadding: false,
      //   label: "Status",
      // },
    ];
  }, []);

  //To fetch all SBUs and Users
  useEffect(() => {
    dispatch(fetchSBUs());
    dispatch(fetchUsers());
  }, [dispatch]);

  useEffect(() => {
    setRootData(() =>
      allSBUs.map((sbu) => {
        const user = allUsers.find((user) => user.userId === sbu.sbuuserId);
        const userName = user ? `${user.firstName} ${user.lastName}` : "";
        return {
          id: sbu.sbuid,
          name: sbu.name,
          description: sbu.description,
          sbuuserId: userName,
          createdDate: displayDateFormart(sbu.createdDate),
          // status: sbu.isActive ? "Active" : "Inactive",
        };
      })
    );
  }, [allSBUs, allUsers]);

  // To set filtered data on change root data
  useEffect(() => {
    setFilteredData(rootData);
  }, [rootData]);

  const handleEdit = (id: string | number) => {
    const editSBURec = allSBUs.find((rec) => rec.sbuid === id);
    setMode("edit");
    setEditData(editSBURec);
    setIsModalOpen(true);
  };

  const createHandler = () => {
    setMode("add");
    setEditData(undefined);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const searchHandler = (searchVal: string): void => {
    setFilteredData(() =>
      searchVal
        ? rootData.filter((info) =>
            Object.values(info).join("").toLowerCase().includes(searchVal)
          )
        : rootData
    );
  };

  return (
    <>
      {!isValidArr(allSBUs) && isSbusFetching ? <Loader /> : null}
      <PageTitle title="SBUs" btnText="Add SBU" onClick={createHandler} />
      <PageSearch placeholder="Search SBUs" searchHandler={searchHandler} />
      <EnhancedTable
        columns={columns}
        data={filteredData}
        handleEdit={handleEdit}
      />
      {isModalOpen && (
        <DialogBox
          isModalOpen={isModalOpen}
          modalTitle={mode === "add" ? "Create SBU" : "Edit SBU"}
          handleModalClose={handleModalClose}
        >
          <SBGForm
            mode={mode}
            data={editData}
            handleModalClose={handleModalClose}
          />
        </DialogBox>
      )}
    </>
  );
};

export default SBUPage;
